import { HttpMethod } from '../../constants';
function replaceEnterpriseId(enterpriseId: string): string {
  return this.path.replace(':enterpriseId', enterpriseId);
}
function replaceBuildingId(buildingId: string): string {
  return this.path.replace(':buildingId', buildingId);
}
function replaceEnterpriseAndBuildingId(enterpriseId: string, buildingId: string): string {
  return this.path.replace(':enterpriseId', enterpriseId).replace(':buildingId', buildingId);
}
function returnPath(): string {
  return this.path;
}
export const buildingEndpoints = {
  [HttpMethod.Get]: {
    EnterpriseBuildings: {
      path: '/enterprises/:enterpriseId/buildings',
      route: replaceEnterpriseId
    },
    PublicEnterpriseBuildings: {
      path: '/p/enterprises/:enterpriseId/buildings',
      route: replaceEnterpriseId
    },
    Building: {
      path: '/buildings/:buildingId',
      route: replaceBuildingId
    },
    BuildingSuggestions: {
      path: '/suggest/buildings',
      route: returnPath
    }
  },
  [HttpMethod.Post]: {
    EnterpriseBuildings: {
      path: '/enterprises/:enterpriseId/buildings',
      route: replaceEnterpriseId
    },
    BatchReassignWorksite: {
      path: '/buildings/batch-reassign',
      route: () => '/buildings/batch-reassign'
    }
  },
  [HttpMethod.Patch]: {
    Building: {
      path: '/buildings/:buildingId',
      route: replaceBuildingId
    }
  },
  [HttpMethod.Delete]: {
    EnterpriseBuilding: {
      path: '/enterprises/:enterpriseId/buildings/:buildingId',
      route: replaceEnterpriseAndBuildingId
    },
    EnterpriseBuildingsBatch: {
      path: '/enterprises/:enterpriseId/buildings/batch',
      route: replaceEnterpriseId
    }
  }
};